import { render, staticRenderFns } from "./GlobalCoinDialogs.vue?vue&type=template&id=fe2780ca&scoped=true&"
import script from "./GlobalCoinDialogs.vue?vue&type=script&lang=js&"
export * from "./GlobalCoinDialogs.vue?vue&type=script&lang=js&"
import style0 from "./GlobalCoinDialogs.vue?vue&type=style&index=0&id=fe2780ca&prod&lang=less&scoped=true&"
import style1 from "./GlobalCoinDialogs.vue?vue&type=style&index=1&id=fe2780ca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2780ca",
  null
  
)

export default component.exports